export default __webpack_public_path__ + "static/media/Saly2.04a8684a.png";